// Package Block
import jwt_decode from "jwt-decode";
import dayjs from "dayjs";
import { notification } from "antd";
// Redux & Configuration Block
import * as authe from "../app/modules/Auth/_redux/authRedux";
import { API_BASE_URL, REFRESH_TOKEN_URL } from "../constants/config";

const overrideurl = localStorage.getItem("overrideurl");

let _API_BASE_URL = overrideurl || API_BASE_URL;

export default function setupAxios(axios, store) {
  const UNAUTHORIZED = 401;
  axios.interceptors.request.use(
    (config) => {
      const {
        auth: { authToken, refreshToken, pilotUrl },
      } = store.getState();
      const user = authToken ? jwt_decode(authToken) : 0;
      const isExpired = dayjs.unix(user.exp).diff(dayjs()) < 1;
        config.url = `${_API_BASE_URL}${config.url.split("/v1")[1]}`;

      // Konnect cross-tenant context: forward pk so the backend resolves the
      // correct remote tenant for every request made while viewing their resources.
      const urlParams = new URLSearchParams(window.location.search);
      const public_key = urlParams.get("pk") || urlParams.get("public_key");
      if (public_key) {
        config.params = { ...config.params, public_key };
      }
      if (authToken && !isExpired) {
        config.headers.Authorization = `Bearer ${authToken}`;
        if (pilotUrl && pilotUrl !== null) {
          const relativePath = config.url.split("/tenant")[1];
          config.url = `${pilotUrl}/tenant${relativePath}`;
        }
        return config;
      }

      const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${refreshToken}`,
      };

      if (isExpired && config.url.split("/")[config.url.split("/").length - 1] !== "authenticate") {
        return new Promise((resolve) => {
          const res = fetch(REFRESH_TOKEN_URL, {
            method: "POST",
            headers: headers,
            body: "",
          });
          res
            .then((r) => r.json())
            .then((result) => {
              config.headers.Authorization = `Bearer ${result.entity.access_token}`;
              store.dispatch(authe.actions.refresh_token(result.entity.access_token, result.entity.refresh_token));
            })
            .then(() => {
              resolve(config);
            })
            .catch(() => {
              localStorage.clear();
              store.dispatch({ type: "[Logout] Action" });
            });
        });
      }
      return config;
    },
    (err) => Promise.reject(err)
  );
  axios.interceptors.response.use(
    (response) => {
      if (response?.data?.warnings) {
        const warnings = response.data.warnings;

        if (Array.isArray(warnings) && warnings?.length) {
          warnings.forEach((msg) => {
            notification.warning({
              message: "Warning",
              description: msg,
              placement: "topRight",
              duration: 5,
            });
          });
        }
      }
      return response;
    },
    (error) => {
      const response = error.response;
      if (!response)
          return Promise.reject(error);
      const status = error.response?.status;

      if (error?.response?.headers["content-type"] === "text/html") {
          console.error("Error:", error);

      } else {
        if (status === UNAUTHORIZED) {
          localStorage.clear();
          store.dispatch({ type: "[Logout] Action" });
        }
        if (
            response.headers["x-pilot-redirect-url"] && !["none", "null"].includes(response.headers["x-pilot-redirect-url"].toLowerCase().trim())
            || (response.status === 403 &&  response.data?.errors?.includes?.("You belong to another segment"))
        ){
            // seems like it's on a wrong segment
            let href = window.location.href
            if(href.startsWith("https://appp.") || href.startsWith("http://appp.")){
              window.location.href= window.location.href.replace("//appp.","//app.")
            } else {
              window.location.href= window.location.href.replace("//app.","//appp.")
            }
        }

      }
      return Promise.reject(error);
    }
  );
}
